import React from "react";
import { isPreviewEnv } from "@/lib/env";

/**
 * Persistent "TEST" environment indicator.
 *
 * Renders a compact amber pill ONLY on the Emergent Preview environment
 * (*.preview.emergentagent.com). On the production/custom domain it renders
 * nothing, so live branding is never affected. Visibility is determined
 * automatically from the hostname — no user setting, role-independent.
 */
export const TestBadge = ({ className = "" }) => {
  if (!isPreviewEnv()) return null;
  return (
    <span
      data-testid="test-env-badge"
      title="You are on the TEST (Preview) environment"
      className={
        "inline-flex items-center rounded-full border border-amber-400/40 " +
        "bg-amber-400/15 px-2.5 py-0.5 text-[11px] font-bold uppercase " +
        "tracking-wider text-amber-400 leading-none select-none " +
        className
      }
    >
      Test
    </span>
  );
};

export default TestBadge;
